// extracted by mini-css-extract-plugin
export var contentContainer = "CruiseCard-module--contentContainer--bf2fe";
export var contentContainerInner = "CruiseCard-module--contentContainerInner--17370";
export var cruiseCard = "CruiseCard-module--cruiseCard--d2cc5";
export var cruiseCardLink = "CruiseCard-module--cruiseCardLink--befdb";
export var heading = "CruiseCard-module--heading--91000";
export var image = "CruiseCard-module--image--ab4b5";
export var link = "CruiseCard-module--link--ef874";
export var linkText = "CruiseCard-module--linkText--67485";
export var logo = "CruiseCard-module--logo--fbea8";